import rudderAnalytics from "../../../utilities/rudderanalytics";

export function initPopupExtensionBanner() {
  const frame = document.querySelector(".rectangle-parent");
  const overlay = document.querySelector(".extension-popup-backdrop");
  if (!frame || !overlay) return;

  const discover_now_button = document.querySelector(".discover-now-button");
  discover_now_button?.addEventListener("click", function () {
    rudderAnalytics.track("web_extension_popup_discover_now_button_clicked");
  });

  var isDesktop = window.innerWidth > 1024;

  function showFrame() {
    frame.classList.add("active");
    overlay.style.display = "block";
    setTimeout(() => {
      overlay.style.opacity = "1";
    }, 10);
  }

  function hideFrame() {
    frame.classList.remove("active");
    overlay.style.opacity = "0";
    setTimeout(() => {
      overlay.style.display = "none";
    }, 500);
  }

  function isExtensionInstalled(callback) {
    var img = new Image();
    img.src =
      "chrome-extension://kdojjbmaidnebdjancpcgajkgeboebpe/templates/images/logo.png";
    img.onload = function () {
      callback(true);
    };
    img.onerror = function () {
      callback(false);
    };
  }

  setTimeout(() => {
    if (isDesktop) {
      isExtensionInstalled(function (installed) {
        if (!installed) {
          showFrame();
        }
      });
    }
  }, 3000);

  const framCloseBtn = document.querySelector(".frame-close-btn");
  if (framCloseBtn) {
    framCloseBtn.addEventListener("click", hideFrame);
  }
}
